<div class="flex-header mat-dialog-title" translate>
  Confirm Deletion
</div>
<div class="flex-content">
  <div translate>
    Are you sure you want to delete this portfolio document?
  </div>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Delete" (clickEvent)="continueClick()" translate></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
  </div>
</div>
